import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import CustomerDetails from './CustomerDetails.js';
import { actionCreators } from './store.js';

class CustomerDetailsContainer extends React.Component {
  componentDidMount = () => {
    const { match } = this.props;
    this.loadCustomerDetails(match.params.adfitNo);
  };

  loadCustomerDetails = (adfitNo) => {
    const { getAccountOverview } = this.props;
    if (this.shouldReloadData()) {
      //reload only on different adfit no
      getAccountOverview(adfitNo);
    }
  };

  shouldReloadData = () => {
    //only reload if adfitNo from query string differs from the one in store
    const { match, customerDetails } = this.props; //query string
    let adfitNo = customerDetails.adfitNo
      ? customerDetails.adfitNo.toLowerCase()
      : '';
    return adfitNo !== match.params.adfitNo.toLowerCase();
  };

  render = () => {
    const { localisation, customerDetails } = this.props;

    const shouldReloadData = this.shouldReloadData();
    return (
      <CustomerDetails
        customerDetails={shouldReloadData ? {} : customerDetails}
        localisation={localisation}
      />
    );
  };
}

CustomerDetailsContainer.propTypes = {
  customerDetails: PropTypes.object,
};

const mapStateToProps = (state) => ({
  customerDetails: state.customerDetails,
  localisation: state.localisation,
});

const mapDispatchToProps = {
  getAccountOverview: actionCreators.getAccountOverview,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CustomerDetailsContainer);
